"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationStatusEnum = void 0;
var ConversationStatusEnum;
(function (ConversationStatusEnum) {
    ConversationStatusEnum["Open"] = "O";
    ConversationStatusEnum["ReOpened"] = "RO";
    ConversationStatusEnum["Closed"] = "C";
    ConversationStatusEnum["Resolved"] = "R";
    ConversationStatusEnum["Pending"] = "P";
    ConversationStatusEnum["WaitingForThirdParty"] = "W";
})(ConversationStatusEnum = exports.ConversationStatusEnum || (exports.ConversationStatusEnum = {}));
